// href only: img src can stay as the raw API string. A clickable
// javascript:/data: URL in <a> would run in the user's session.
export const isSafeHttpHref = (url?: string | null): url is string => {
  if (!url?.trim()) {
    return false
  }

  try {
    const parsed = new URL(url.trim(), 'https://example.invalid')

    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}
